

export default {
    levelZero: 'level-0',
    odd: 'level-odd',
    even: 'level-even'
};
